export default __webpack_public_path__ + "2613a6bfabeba65aa084bf927d662b98.png";